export default "__VITE_ASSET__BdFwr6_Y__"